var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1516 3.47C11.5433 2.84333 12.456 2.84333 12.8476 3.47L22.8476 19.47C23.2639 20.136 22.7851 21 21.9996 21H1.99965C1.21421 21 0.735367 20.136 1.15165 19.47L11.1516 3.47ZM20.1962 18.9999L12.0004 5.88672L3.80469 18.9999H20.1962ZM11.999 13C12.549 13 12.999 12.55 12.999 12V10C12.999 9.45 12.549 9 11.999 9C11.449 9 10.999 9.45 10.999 10V12C10.999 12.55 11.449 13 11.999 13ZM12.999 15V17H10.999V15H12.999Z",
    fill: "#FCA033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.72312aee0fa8ad0c38319b6bed3882a6.svg";
export { ForwardRef as ReactComponent };